import type { HTMLComponent } from "@commercekit/react";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import WvDownloadIcon from "../atoms/WvDownloadIcon";
import { useId } from "react";

const WvProductSpecification: HTMLComponent<{
  specifications?: { name: string; val: string }[];
  assets?: { name: string; url: string }[];
}> = ({ specifications, assets }) => {
  const { $pt } = usePrismicLabels();
  const collapseId = useId();

  return (specifications ?? assets)?.length ? (
    <div
      className="px-0 mx-2.5 lg:px-2.5 lg:mx-0 border-b border-gray-lightest lg:border-b-0 basis-full lg:basis-6/12"
      id="specification"
    >
      <div className="hidden lg:block pdp-section-card">
        <h2 className="heading md underlined sans-serif strong mdl left py-3">
          {assets?.length
            ? $pt("product_label_product_assets")
            : $pt("product_label_product_specification")}
        </h2>
        <div className="pdp-collapse">
          {/* closed by default */}
          <input
            type="checkbox"
            id={collapseId}
            className="pdp-collapse__input"
          />
          <div className="pdp-collapse__body pdp-collapse__body--specs">
            <div className="table-wrapper">
              <table className="spec-table">
                <tbody className="spec-table__body">
                  {(specifications ?? assets)?.map((specification) => {
                    return (
                      <tr key={specification?.name} className="spec-table__row">
                        <th className="spec-table__heading">
                          {specification?.name}
                        </th>
                        {"url" in specification ? (
                          <td className="spec-tbale__value">
                            <a
                              href={specification.url}
                              download={specification.name}
                              target="_blank"
                              rel="noreferrer"
                              className="text-success cc-link"
                            >
                              <WvDownloadIcon size={28} />
                            </a>
                          </td>
                        ) : (
                          <td className="spec-tbale__value">
                            {["True", "False"].includes(specification?.val)
                              ? $pt(specification?.val.toLocaleLowerCase())
                              : specification?.val}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <span className="pdp-collapse__fade" aria-hidden="true" />
          </div>
          <label htmlFor={collapseId} className="pdp-collapse__toggle">
            <span className="pdp-collapse__more">
              {$pt("customer_review_show_more")}
            </span>
            <span className="pdp-collapse__less">
              {$pt("customer_review_show_less")}
            </span>
          </label>
        </div>
      </div>
    </div>
  ) : null;
};

export default WvProductSpecification;
